
//=========== * header * ============//
window.onload = () => {
    //pc용
    const box = document.querySelector('.pc-aside-container02')




    //모바일용
    const mobox = document.querySelector('.mo-aside')
    //뷰넓이 가져오기
    const wrapWith = document.body.offsetWidth;
    console.log(wrapWith)
    // 뷰넓이가 760 보다 작을때 동작할 함수

    if(wrapWith < 768) {
        mobileScrollEvent();
    }else {
        scrollEvent();
    }
    AOS.init()


    /*모바일 사이즈 aside*/
    const mobileAsideMenu_contact = document.querySelector('.mo-aside2')
    const mobileAsideMenu_menu = document.querySelector('.mo-aside')
    // document.querySelector('.mo-nav-menu').addEventListener('click', function(){
    //     mobileAsideMenu_contact.style.transform = "translateX(0)"
    //
    // })
    mobileAsideMenu_menu.addEventListener('click', (e) => {
        mobileAsideMenu_menu.style.transform = 'translateX(100%)'
    })
    document.querySelector('.mo-menu-btn').addEventListener('click', function(e){
        mobileAsideMenu_menu.style.transform = "translateX(0)"
        motoggleTransition(mobox)
    })

    document.querySelector('.mo-aside-close-btn2').addEventListener('click', function(e){
        mobileAsideMenu_contact.style.transform = "translateX(100%)"

    })
    document.querySelector('.mo-aside-close-btn').addEventListener('click', function(e){
        mobileAsideMenu_menu.style.transform = "translateX(100%)"
        motoggleTransition(mobox)
    })


    /*pc 사이즈 aside*/
    const moAsideMenu = document.querySelector("aside");
    document.querySelector('.pc-aside-btn').addEventListener('click', function(){
        moAsideMenu.style.transform = "translateX(0)"
        toggleTransition(box)
    })
    const test = document.querySelector('.pc-aside-btn');
    console.log(test);
    document.querySelector('.pc-aside-container').addEventListener('click', function(e){
        moAsideMenu.style.transform = "translateX(100%)"
    })
    document.querySelector('.pc-aside-close-btn').addEventListener('click', function(e){
        moAsideMenu.style.transform = "translateX(100%)"
        toggleTransition(box)
    })


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });




}
//== PC ASIDE 클릭함수
function toggleTransition(box){

    box.addEventListener('transitionend', () => {
        const home = box.querySelector('.home_toggle')
        //about
        const about = box.querySelector('.about_toggle')
        //portfolio
        const portfolio = box.querySelector('.portfolio_toggle')
        //new
        const Nnew = box.querySelector('.new_toggle')
        //contact
        const contact = box.querySelector('.contact_toggle')
        //item
        const info = box.querySelector('.info')
        //youbtn
        const youbtn = box.querySelector('.youtube-contents')

        home.classList.toggle('active');
        home.style.transitionDelay = '0.3s'
        about.classList.toggle('active');
        about.style.transitionDelay = '0.5s'
        portfolio.classList.toggle('active');
        portfolio.style.transitionDelay = '0.8s'
        Nnew.classList.toggle('active');
        Nnew.style.transitionDelay = '1s'
        contact.classList.toggle('active');
        contact.style.transitionDelay = '1.3s'
        info.classList.toggle('active');
        info.style.transitionDelay = '1.6s'
        youbtn.classList.toggle('active');
        youbtn.style.transitionDelay = '1.9s'

    },{once:true})
}
//== MOBILE ASIDE 클릭함수
function motoggleTransition(box){

    box.addEventListener('transitionend', () => {
        const home = box.querySelector('.home_toggle')
        //about
        const about = box.querySelector('.about_toggle')
        //portfolio
        const portfolio = box.querySelector('.portfolio_toggle')
        //new
        const Nnew = box.querySelector('.new_toggle')
        //contact
        const contact = box.querySelector('.contact_toggle')
        //tel
        const tel = box.querySelector('.tel_toggle')
        //youbtn
        const youbtn = box.querySelector('.mo-youtube-contents')

        home.classList.toggle('active');
        home.style.transitionDelay = '0.2s'
        about.classList.toggle('active');
        about.style.transitionDelay = '0.5s'
        portfolio.classList.toggle('active');
        portfolio.style.transitionDelay = '0.8s'
        Nnew.classList.toggle('active');
        Nnew.style.transitionDelay = '1s'
        contact.classList.toggle('active');
        contact.style.transitionDelay = '1.3s';
        tel.classList.toggle('active');
        tel.style.transitionDelay = '1.6s'
        youbtn.classList.toggle('active');
        youbtn.style.transitionDelay = '1.9s'

    },{once:true})
}


//=========== * header 끝* ============//



//=========== * section03 scroll 시작 * ============//
//swiper 에 이벤트 추가하기 위해서 변수 가죠옴
const sc3Sw = document.querySelector('.sc3-swiper');
//백그라운드 이미지 변경할 el
const sc3Background = document.querySelector('.section03-mobile');

const sc3Swiper = new Swiper('.sc3-swiper', {
    direction: 'horizontal',
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 30,
    speed: 1000,
})

//=========== * slide 시작 * ============//
const aboutsc3Swiper = new Swiper('.about-sc3-swiper', {
    speed: 900,
    loop: true,
    pagination: {
        el: '.about-sc3-pagenaion',
        clickable: true
    },
    navigation: {
        nextEl: '.cast3-sc3-next',
        prevEl: '.cast3-sc3-prev',
    },
    autoplay: {
        delay: 5000,
    }
});
//=========== * slide 끝 * ============//

//스크롤바 전체 웨퍼
const scrollWap = document.querySelector('.scroll-bar-wrapper')
//스크롤바 카드 아이템들
const cards = document.querySelectorAll('.card-list .card')
//반복문을 위한 아이템들 갯수
const cardsLength = cards.length;

//2번페이지 동영상 커지기 sj
const newMiddleWrap2 = document.querySelector('.video_sc_02')
//백그라운드 어두워지게 하기 sj
const opacityBg = document.querySelector('.opacity_background');
//텍스트 색깔변경 sj
const change_centertext1 = document.querySelector('.section04_title')
const change_centertext2 = document.querySelector('.how_content')

//현재 엑티크 할 클래스 제외하고 나머지 클래스 제거하는 함수
const activeChecked = (activeN) => {
    for(let i = 0 ; i <= cardsLength; i++) {
        if(i == activeN){
            scrollWap.classList.add(`active${activeN}`)
        }else {
            scrollWap.classList.remove(`active${i}`)
        }
    }
}

const scrollEvent = function() {
    scrollTop = document.documentElement.scrollTop;
    // console.log(scrollTop);
    //반응형 사이즈를 위한 스크롤값 조건문 (max-width:1360이상일때 동작)


    window.addEventListener('scroll', () => {
        scrollTop = document.querySelector('html').scrollTop
        //스크롤 위치 잡기
        console.log(scrollTop, 'scroll 값')


        if (scrollTop < 1250) {
            if(newMiddleWrap2) {
                newMiddleWrap2.classList.remove('active')
                opacityBg.style.opacity = "0";
                change_centertext1.style.color="#000"
                change_centertext2.style.color="#000"
            }


        } else if (scrollTop > 1250) {
            // console.log(newMiddleWrap2)
            if(newMiddleWrap2) {
                newMiddleWrap2.classList.add('active')
                opacityBg.style.opacity = "1";
                change_centertext1.style.color="#FFF"
                change_centertext2.style.color="#FFF"
            }
        }


        if(scrollTop < 4906) {

            activeChecked(1);

        }else if (5306 > scrollTop && scrollTop > 4906) {
            activeChecked(2);

        }else if (5706 > scrollTop && scrollTop > 5306) {
            activeChecked(3);

        }else if(7491 > scrollTop && scrollTop > 5306) {
            activeChecked(4);
        }else if(scrollTop > 7491) {
            activeChecked(5);
        }
        // if(scrollTop )
        if(scrollTop >9300) {
            console.log(aboutsc3Swiper.autoplay)
            aboutsc3Swiper.autoplay.start();


        }else{
            aboutsc3Swiper.autoplay.stop();
        }

    })

}
scrollEvent();
const mobileScrollEvent = function () {
    if(sc3Sw) {
        sc3Sw.addEventListener('touchend', () => {
            //터치이벤트가 발생할때마다 모바일-섹션3번에서 엑티브 된 요소 찾아오기
            const active = document.querySelector('.sc3-mo-wrapper .swiper-slide-active');
            console.log(active);
            if(active.classList.contains('item1')) {
                sc3Background.style.backgroundImage = 'url(/assets/images/section03/img01.png)'
            }else if(active.classList.contains('item2')) {
                sc3Background.style.backgroundImage = 'url(/assets/images/section03/img02.png)'
            }else if(active.classList.contains('item3')) {
                sc3Background.style.backgroundImage = 'url(/assets/images/section03/img03.png)'
            }else if(active.classList.contains('item4')) {
                sc3Background.style.backgroundImage = 'url(/assets/images/section03/img04.png)'
            }
        })
    }

}


// **section 03 끝

//=========== * section03 scroll 끝 * ============//


//============================ * ALL SWIPER * ===========================//


const sc5SwiperMenuA01 = ['CONVEYOR', 'ELECTRICAL']
const showSwiper05_textA01 = document.querySelectorAll('.swiper-text_box')

const allSwiper = new Swiper('.all-swiper', {
    pagination: {
        el: '.all-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (sc5SwiperMenuA01[index]) + '</span>';
        }
    },
    slidesPerView: 1,
    spaceBetween: 0,
    resistanceRatio: 0,
    speed: 1000,
    on: {
        slideChange: function (swiper) {

            // for (let i = 0; i < showSwiper05_textA01.length; i++) {
            //     if (i == swiper.activeIndex) {
            //         showSwiper05_textA01[i].classList.add('active');
            //     } else {
            //         showSwiper05_textA01[i].classList.remove('active')
            //     }
            // }
            // console.log(swiper)
            allSwiper.slideTo(swiper.activeIndex);
        }
    }
});

//=========== * service1 시작 * ============//
const sc5SwiperMenu = ['PLC Programing', 'HMI Monitering', 'PANNEL 제작', '하드웨어 전기공사']
const showSwiper05_text01 = document.querySelectorAll('.swiper-text_box')

const swipersection05 = new Swiper('.sc5-swiper', {
    pagination: {
        el: '.sc5-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (sc5SwiperMenu[index]) + '</span>';
        }
    },
    slidesPerView: 1,
    spaceBetween: 50,
    speed: 1000,
    on: {
        slideChange: function (swiper) {

            for (let i = 0; i < showSwiper05_text01.length; i++) {
                if (i == swiper.activeIndex) {
                    showSwiper05_text01[i].classList.add('active');
                } else {
                    showSwiper05_text01[i].classList.remove('active')
                }
            }
            // console.log(swiper)
            sc5NumbSwiper.slideTo(swiper.activeIndex);
        }
    }
});

const sc5NumbSwiper = new Swiper('.number-swiper', {
    touchRatio: 0,
    touchRatio: 0,
    speed: 1000
});

const sc5PrevBtn = document.querySelector('.sc5-prev-btn ');
const sc5NextBtn = document.querySelector('.sc5-next-btn ');

if(sc5PrevBtn && sc5NextBtn) {
    sc5PrevBtn.addEventListener('click',()=>{
        swipersection05.slidePrev();
    })
    sc5NextBtn.addEventListener('click',()=>{
        swipersection05.slideNext();
    })
}


//=========== * service 끝 * ============//
//=========== * service2 시작 * ============//
const sc5SwiperMenu2 = ['STANDARD', 'TILTING', '주문제작']
const showSwiper05_text02 = document.querySelectorAll('.swiper-text_box2')

const swipersection05_02 = new Swiper('.sc5-swiper2', {
    pagination: {
        el: '.sc5-swiper-pagination2',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (sc5SwiperMenu2[index]) + '</span>';
        }
    },
    slidesPerView: 1,
    spaceBetween: 50,
    speed: 1000,
    on: {
        slideChange: function (swiper) {

            for (let i = 0; i < showSwiper05_text02.length; i++) {
                if (i == swiper.activeIndex) {
                    showSwiper05_text02[i].classList.add('active');
                } else {
                    showSwiper05_text02[i].classList.remove('active')
                }
            }
            // console.log(swiper)
            sc5NumbSwiper2.slideTo(swiper.activeIndex);
        }
    }
});

const sc5NumbSwiper2 = new Swiper('.number-swiper2', {
    touchRatio: 0,
    touchRatio: 0,
    speed: 1000
});

const sc5PrevBtn2 = document.querySelector('.sc5-prev-btn2');
const sc5NextBtn2 = document.querySelector('.sc5-next-btn2');

if(sc5PrevBtn2 && sc5NextBtn2) {
    sc5PrevBtn2.addEventListener('click',()=>{
        swipersection05_02.slidePrev();
    })
    sc5NextBtn2.addEventListener('click',()=>{
        swipersection05_02.slideNext();
    })
}


//=========== * service2 끝 * ============//

//=========== * service3 시작 * ============//
const sc5SwiperMenu3 = ['STAIRWAY', 'PC TABLE', 'COVER & DOOR']
const showSwiper05_text03 = document.querySelectorAll('.swiper-text_box3')

const swipersection05_03 = new Swiper('.sc5-swiper3', {
    pagination: {
        el: '.sc5-swiper-pagination3',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (sc5SwiperMenu3[index]) + '</span>';
        }
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    on: {
        slideChange: function (swiper) {

            for (let i = 0; i < showSwiper05_text03.length; i++) {
                if (i == swiper.activeIndex) {
                    showSwiper05_text03[i].classList.add('active');
                } else {
                    showSwiper05_text03[i].classList.remove('active')
                }
            }
            // console.log(swiper)
            sc5NumbSwiper3.slideTo(swiper.activeIndex);
        }
    }
});

const sc5NumbSwiper3 = new Swiper('.number-swiper3', {
    touchRatio: 0,
    touchRatio: 0,
    speed: 1000
});

const sc5PrevBtn3 = document.querySelector('.sc5-prev-btn3');
const sc5NextBtn3 = document.querySelector('.sc5-next-btn3');

if(sc5PrevBtn3 && sc5NextBtn3) {
    sc5PrevBtn3.addEventListener('click',()=>{
        swipersection05_03.slidePrev();
    })
    sc5NextBtn3.addEventListener('click',()=>{
        swipersection05_03.slideNext();
    })
}


//=========== * service3 끝 * ============//



// ** contact-form 용 시작
const requestForm = document.querySelector('form')
if(requestForm){
    requestForm.addEventListener('submit', function(e) {
        e.preventDefault()

        const const_phone = document.querySelector('#input-phone').value;
        const const_name = document.querySelector('#input-name').value;
        const const_email = document.querySelector('#input-email').value;

        const data = {
            const_phone,
            const_name,
            const_email
        }
        console.log(data)
        $.ajax({
            url: '/consultation',
            type:'POST',
            async:false,
            cache: false,
            data,
            success:function() {
                alert('신청접수가 완료되었습니다.');
                this.data.const_phone = ''
                this.data.const_name = ''
                this.data.const_email = ''
            }
        })
    })
}

// 전화번호 하이픈 추가
function oninputPhone(target) {

    target.value = target.value
        .replace(/[^0-9]/g, '')
        .replace(/(^02.{0}|^01.{1}|[0-9]{3,4})([0-9]{3,4})([0-9]{4})/g, "$1-$2-$3");
}


const privacyAgree = document.querySelector('.privacy-agree')
const privacyOpen = document.querySelector('.btn-view-privacy')
const privacText = document.querySelector('.privacy-agree-container p')
const privacyClose = document.querySelector('#privacy-close')
if(privacyOpen){
    privacyOpen.addEventListener('click', function(){
        privacyAgree.style.display = "block";
        privacyClose.addEventListener('click', function(){
            privacyAgree.style.display = "none";
        })
    })
}

privacText.innerText = `
지디테크는 (이하 '회사'는)  
고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.

회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.

1. 개인정보의 취급 목적 <주식회사 지디테크>('http://gdtechnology.kr//'이하 '지디테크')은(는) 개인정보를 다음의 목적을 위해 취급합니다. 취급한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.
가. 기타
여행 및 항공 숙박 서비스 제공 등을 목적으로 개인정보를 취급합니다.



2. 개인정보 파일 현황
1. 개인정보 파일명 : 회사는 상담, 예약 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
- 개인정보 항목 : 이메일, 휴대전화번호, 성별, 이름, 결혼여부, 서비스 이용 기록
- 수집방법 : 홈페이지(상담게시판) , 전화/팩스를 통한 정보요청
- 보유근거 : 고객 상담, 서비스 신청
- 보유기간 : 5년
- 관련법령 : 소비자의 불만 또는 분쟁취급에 관한 기록 : 3년, 대금결제 및 재화 등의 공급에 관한 기록 : 5년, 계약 또는 청약철회 등에 관한 기록 : 5년




3. 개인정보의 취급 및 보유 기간

① <주식회사 지디테크>('지디테크')은(는) 법령에 따른 개인정보 보유•이용기간 또는 정보주체로부터 개인정보를 수집시에 동의 받은 개인정보 보유,이용기간 내에서 개인정보를 취급,보유합니다.
원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.

② 각각의 개인정보 취급 및 보유 기간은 다음과 같습니다.
표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에 관한 법률)
계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)
신용정보의 수집/취급 및 이용 등에 관한 기록 : 3년 (신용정보의 이용 및 보호에 관한 법률)


4. 개인정보의 제3자 제공에 관한 사항

① <주식회사 지디테크>('http://gdtechnology.kr/'이하 '지디테크')은(는) 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
② <주식회사 지디테크>('http://gdtechnology.kr/')은(는) 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.

- 개인정보를 제공받는 자 : 지디테크 

- 제공받는 자의 개인정보 이용목적 : 문의용
- 제공받는 자의 보유.이용기간: 서비스 제공 이외의 목적으로 사용하지 않으며, 목적 달성시 즉각 파기합니다.


5. 개인정보취급 위탁

① <주식회사 지디테크>('지디테크')은(는) 원활한 개인정보 업무취급을 위하여 다음과 같이 개인정보 취급업무를 위탁하고 있습니다.
1. <서버보안관리>
- 위탁받는 자 (수탁자) : 하군랩
- 위탁하는 업무의 내용 : 개인정보 보관기간 초과자 취급
- 위탁기간 : 1년


② <주식회사 지디테크>('http://gdtechnology.kr//'이하 '지디테크')은(는) 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 취급금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 취급하는지를 감독하고 있습니다.

③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 취급방침을 통하여 공개하도록 하겠습니다.

6. 정보주체와 법정대리인의 권리•의무 및 그 행사방법 이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.
① 정보주체는 주식회사 지디테크에 대해 언제든지 개인정보 열람,정정,삭제,취급정지 요구 등의 권리를 행사할 수 있습니다.
② 제1항에 따른 권리 행사는주식회사 지디테크에 대해 개인정보 보호법 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 주식회사 지디테크은(는) 이에 대해 지체 없이 조치하겠습니다.
③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
④ 개인정보 열람 및 취급정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
⑥ 주식회사 지디테크은(는) 정보주체 권리에 따른 열람의 요구, 정정•삭제의 요구, 취급정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.



7. 취급하는 개인정보의 항목 작성 

① <주식회사 지디테크>('http://gdtechnology.kr//'이하 '지디테크')은(는) 다음의 개인정보 항목을 취급하고 있습니다.
1<기타>
- 필수항목 : 이름, 연락처
- 선택항목 : 이메일




8. 개인정보의 파기<주식회사 지디테크>('지디테크')은(는) 원칙적으로 개인정보 취급목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
-파기절차
이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.

-파기기한
이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 취급 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 취급이가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
-파기방법
전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
- 이용자들이 사전에 동의한 경우
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

9. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항
주식회사 지디테크은정보주체의 이용정보를 저장하고 수시로 불러오는 ‘쿠키’를 사용하지 않습니다.
10. 개인정보 보호책임자 작성

①  주식회사 지디테크(‘http://gdtechnology.kr/’이하 ‘지디테크) 은(는) 개인정보 취급에 관한 업무를 총괄해서 책임지고, 개인정보 취급과와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자 
성명 :형원석
직책 :부장
직급 :부장
연락처 : 010-9482-8990, gdtechnology@naver.com,  010-9482-8990

※ 개인정보 보호 담당부서로 연결됩니다.

② 정보주체께서는 주식회사 지디테크(‘http://gdtechnology.kr//’이하 ‘지디테크) 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 주식회사 지디테크(‘http://gdtechnology.kr/’이하 ‘지디테크) 은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.



11. 개인정보 취급방침 변경
①이 개인정보취급방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.



12. 개인정보의 안전성 확보 조치 <주식회사 지디테크>('지디테크')은(는) 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.
1. 정기적인 자체 감사 실시
개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.

2. 해킹 등에 대비한 기술적 대책
<주식회사 지디테크>('지디테크')은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신•점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.

3. 개인정보의 암호화
이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.

4. 접속기록의 보관 및 위변조 방지
개인정보취급시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.

5. 개인정보에 대한 접근 제한
개인정보를 취급하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.

6. 비인가자에 대한 출입 통제
개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.



13. 개인정보 열람청구
① 정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. <지디테크>(‘http://gdtechnology.kr//'이하 '지디테크')은(는) 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다..

개인정보관리책임자 성명 : 형원석
전화번호 : 02-720-8876
이메일 : 1000syb_hws@naver.com

② 정보주체께서는 제1항의 열람청구 접수․취급부서 이외에, 행정안전부의 ‘개인정보보호 종합지원 포털’ 웹사이트(www.privacy.go.kr)를 통하여서도 개인정보 열람청구를 하실 수 있습니다.


▶ 행정안전부 개인정보보호 종합지원 포털 → 개인정보 민원 → 개인정보 열람등 요구 (본인확인을 위하여 아이핀(I-PIN)이 있어야 함)

귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.

기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

1.개인분쟁조정위원회 (www.1336.or.kr/1336)
2.정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)
3.대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr/02-3480-3600)
4.경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)


개인정보 취급방침 시행 및 수정 이력
- 2009 년 01 월 01 일 부터 시행
- 2016 년 12 월 01 일 수정
- 2017 년 04 월 01 일 수정
- 2018 년 02 월 26 일 수정
`;

// **footer 개인정보 버튼 시작 상담 신청시 반드시 필요
const footerPrivacyBtn = document.querySelector('.footer-btn-view-privacy');


footerPrivacyBtn.addEventListener('click', function(){
    privacyAgree.style.display = "block";
    privacyClose.addEventListener('click', function(){
        privacyAgree.style.display = "none";
    })
})
// **footer 개인정보 버튼 끝
// ** contact-form 용 끝
